/**
 * Validation utilities for CRM
 */

export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function validatePhone(phone: string): boolean {
  // Israeli phone formats:
  // - 3 digits + "-" + 7 digits (e.g., 050-1234567)
  // - 2 digits + "-" + 7 digits (e.g., 03-1234567)
  // - 9 digits (e.g., 031234567)
  // - 10 digits (e.g., 0501234567)
  const phoneRegex = /^(\d{3}-\d{7}|\d{2}-\d{7}|\d{9}|\d{10})$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
}

export function validateTaxId(taxId: string): boolean {
  // Israeli tax ID (HP/Osek Mursheh): exactly 9 digits
  const taxIdRegex = /^\d{9}$/;
  return taxIdRegex.test(taxId);
}

export function formatTaxIdInput(value: string): string {
  // Only allow digits
  return value.replace(/\D/g, '');
}

export function formatPhoneInput(value: string): string {
  // Only allow digits and hyphens
  return value.replace(/[^\d-]/g, '');
}

export function formatPhoneDisplay(phone: string): string {
  // Format phone for display with hyphen. Only apply the 9/10 templates to Israeli mobile
  // or landline numbers (leading "0"). Non-0-leading numbers (e.g. 1700... business lines)
  // would otherwise be mangled into "170-0123456" and pass validation as a wrong number.
  const cleaned = phone.replace(/[^\d]/g, '');

  if (!cleaned.startsWith('0')) {
    return phone;
  }

  if (cleaned.length === 10) {
    // 10 digits: 050-1234567
    return cleaned.slice(0, 3) + '-' + cleaned.slice(3);
  } else if (cleaned.length === 9) {
    // 9 digits: 03-1234567
    return cleaned.slice(0, 2) + '-' + cleaned.slice(2);
  }

  return phone;
}
